import { Component } from '@angular/core';

@Component({
  selector: 'app-finalize-dialog',
  templateUrl: 'finalize-dialog.component.html',
})
export class FinalizeDialogComponent {}
